module.exports = __webpack_public_path__ + "img/ike-min.b610edd1.png";